import api from "../utils/axiosInstance";

const API = "personalarea";


  export const getWithdrawToAccount = async (data) => {
    try {
      const response = await api.post(`/${API}/wallet/accounts`, data);
      return response;
    } catch (error) {
      return error;
    }
  };

  export const getWithdrawFromAccount = async (data) => {
    try {
      const response = await api.post(`/${API}/wallet/from-accounts/get`, data);
      return response;
    } catch (error) {
      return error;
    }
  };

  export const withdraw2FA = async (data) => {
    try {
      const response = await api.post(`/${API}/withdraw/2fa-verify`, data);
      return response;
    } catch (error) {
      return error;
    }
  };

  
  export const createTransfer = async (data) => {
    try {
      const response = await api.post(`/${API}/transfer/transfer`, data);
      return response;
    } catch (error) {
      return error;
    }
  };

// new
    export const createWithdraw = async (data) => {
    try {
      const response = await api.post(`/wallet/create-withdraw`, data);
      return response;
    } catch (error) {
      return error;
    }
  };
